import { createDetailStore } from './createDetailStore';
import { createSearchApi } from './searchApi';

const store = createDetailStore(createSearchApi());

export const useDetail = () => store;
